import axios from "axios";
import ArrayStore from "devextreme/data/array_store";
import CustomStore from "devextreme/data/custom_store";
import forEach from "lodash/forEach";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import keyBy from "lodash/keyBy";
import keys from "lodash/keys";
export const HIGHLIGHT_FIELD_NAME = {
    HIGHLIGHT: "_Highlight",
    HIGHLIGHTED_CELLS_COUNT: "_HighlightedCellsCount",
    HIGHLIGHTED_TIMER_ID: "_HighlightedTimerId"
};
export const CELL_NAME_FOR_STORE_KEY_FIELD = "store_key_cell";
const getStoreChanges = (prevData = [], newData = [], keyExpr = "Id") => {
    const prevDataMap = keyBy(prevData, keyExpr);
    const newDataMap = keyBy(newData, keyExpr);
    const changes = [];
    const prevDataKeys = new Set(keys(prevDataMap));
    forEach(newDataMap, (e, key) => {
        prevDataKeys.delete(key);
        if (!prevDataMap[key]) {
            changes.push({
                type: "insert",
                data: { ...e, [HIGHLIGHT_FIELD_NAME.HIGHLIGHT]: true },
                index: 0,
                key: get(e, keyExpr)
            });
        }
        else if (!isEqual(e, prevDataMap[key])) {
            changes.push({
                type: "update",
                data: e,
                key: get(e, keyExpr)
            });
        }
    });
    forEach(Array.from(prevDataKeys), keyToRemove => {
        changes.push({
            type: "remove",
            key: get(prevDataMap[keyToRemove], keyExpr)
        });
    });
    return changes;
};
export const buildDataSource = (data, prevData, grid, keyExpr = "Id", onChanged = undefined) => {
    var _a, _b;
    const store = (_b = (_a = grid === null || grid === void 0 ? void 0 : grid.instance) === null || _a === void 0 ? void 0 : _a.getDataSource()) === null || _b === void 0 ? void 0 : _b.store();
    if (store) {
        const changes = getStoreChanges(prevData, data, keyExpr);
        if (changes.length) {
            store.push(changes);
        }
        return undefined;
    }
    return {
        store: new ArrayStore({
            key: keyExpr,
            data
        }),
        reshapeOnPush: true,
        pushAggregationTimeout: 1,
        onChanged
    };
};
export const buildRemoteDataSource = (loadUrl, onInProgressChanged, onHasDataChanged, showError) => new CustomStore({
    load: (opts) => {
        onInProgressChanged && onInProgressChanged(true);
        try {
            return axios
                .post(loadUrl, opts)
                .then((response) => {
                if (!response.data) {
                    onHasDataChanged &&
                        onHasDataChanged({ hasData: false, options: opts, response: undefined });
                    return { data: [], totalCount: 0 };
                }
                const responseData = response.data.data;
                const tableData = get(response.data.data, "tableData", response.data.data);
                if (response.data.state === 0) {
                    onHasDataChanged &&
                        onHasDataChanged({
                            hasData: !isEmpty(tableData.data),
                            options: opts,
                            response: responseData
                        });
                    return tableData;
                }
                onHasDataChanged &&
                    onHasDataChanged({ hasData: false, options: opts, response: responseData });
                showError && responseData && showError(responseData);
                return { data: [], totalCount: 0 };
            })
                .finally(() => onInProgressChanged && onInProgressChanged(false));
        }
        catch (_) {
            onInProgressChanged && onInProgressChanged(false);
            onHasDataChanged &&
                onHasDataChanged({ hasData: false, options: opts, response: undefined });
            return Promise.resolve();
        }
    }
});
export const clearSelection = (grid) => {
    if (!(grid === null || grid === void 0 ? void 0 : grid.instance))
        return;
    const curFilter = grid.instance.option("selectionFilter");
    (!curFilter || curFilter.length) && grid.instance.option("selectionFilter", []);
};
export const updateDimensions = (grid, delay = 0, callback = undefined) => {
    var _a;
    const component = grid === null || grid === void 0 ? void 0 : grid.instance;
    if (!component || !((_a = component.element()) === null || _a === void 0 ? void 0 : _a.isConnected))
        return;
    const timer = component.option("updateDimensionsTimer");
    if (timer)
        clearTimeout(timer);
    component.option("updateDimensionsTimer", setTimeout(() => {
        var _a;
        if (!component || !((_a = component.element()) === null || _a === void 0 ? void 0 : _a.isConnected))
            return;
        component.updateDimensions();
        callback && callback();
    }, delay));
};
